import clsx from 'clsx'

interface Props {
  label: string
  value: string | number | null | undefined
  unit?: string
  hint?: string
  tone?: 'recovery' | 'strain' | 'sleep' | 'neutral'
  score?: number | null // 0-100, used to color recovery pill
}

export default function StatCard({ label, value, unit, hint, tone = 'neutral', score }: Props) {
  const display = value == null || value === '' ? '—' : value
  const toneClass = colorFor(tone, score)
  return (
    <div className="rounded-xl border border-stone-200 bg-white p-5 shadow-sm">
      <div className="text-xs uppercase tracking-wider text-stone-500">{label}</div>
      <div className="mt-2 flex items-baseline gap-1">
        <div className={clsx('text-4xl font-semibold tabular-nums', toneClass)}>{display}</div>
        {unit && <div className="text-sm text-stone-500">{unit}</div>}
      </div>
      {hint && <div className="mt-1 text-xs text-stone-500">{hint}</div>}
    </div>
  )
}

function colorFor(tone: string, score?: number | null): string {
  if (tone === 'recovery' && score != null) {
    if (score >= 67) return 'text-whoop-recovery-high'
    if (score >= 34) return 'text-whoop-recovery-mid'
    return 'text-whoop-recovery-low'
  }
  if (tone === 'strain') return 'text-whoop-strain'
  if (tone === 'sleep') return 'text-whoop-sleep'
  return 'text-stone-900'
}
